import React from "react";

const determineState = (activeIndex: number, index: number) => {
  if (activeIndex > index) return "complete";
  if (activeIndex === index) return "active";
  return "incomplete";
};

const useProgressState = <T extends Record<string, unknown>[]>(steps: T) => {
  const [activeStep, setActiveStep] = React.useState(0);
  const [stepsStatus, setStepsStatus] = React.useState(steps.map(() => false));

  const setStatus = (index: number, complete: boolean) => {
    let newStepsStatus = stepsStatus;
    newStepsStatus[index] = complete;

    setStepsStatus(newStepsStatus);
  };

  return {
    getState: (index: number) => determineState(activeStep, index),
    onClick: (index: number) => setActiveStep(index),
    setStatus: (index: number, complete: boolean) => setStatus(index, complete),
    getStatus: (index: number) => stepsStatus[index],
    activeStep,
  };
};

export default useProgressState;
